/* eslint-disable no-bitwise */
// eslint-disable-next-line max-classes-per-file
import { SimpleSelectionItem } from "~app/common/components/selector/simple-selection-item";
import { SkogsvardAtgardsGrupp, SkogsvardAtgardsTyp, SkogsvardStatus, VirkeskopAtgardsgrupper } from "~app/common/models/constants";
import { EntityDTO } from "~app/common/models/entity-models";
import { Period } from "~app/common/models/period";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { DateUtils } from "~app/common/utils/date-utils";
import { AtgardStatusExtraKartinfo } from "./atgardstatus/atgardstatuses-models";
import { AnsvarigAnvandare } from "./avtal-models";
import { Planeringsstatus } from "./planeringsstatus";

export interface IVirkeskopMattslagRequest {
    produktionsomradeId: number;
    mattslag: string;
    handelssortimentId?: number;
    handelssortimentsGruppId?: number;
}

export interface IVirkeskopMattslagResponse {
    konverteringsfaktor: number;
}

export interface IAtgardstypResponse {
    atgardsgrupp?: string;
    atgardstyper?: ITypeAheadResult[];
}
export class VKAtgardArbetsorderDTO {
    id?: number;
    guid?: string;
    beteckning?: string;
    namn?: string;
    produktionsStatus?: string;
    periodsattPeriod?: string;
    operationer?: VKAtgardArbetsorderOperationDTO[];
}
export class VKAtgardArbetsorderOperationDTO {
    id?: number;
    startdatum?: Date;
    slutdatum?: Date;
    namn?: string;
    typ?: string;
    operationstyp?: string;
    skotningPaborjadDatum?: Date;
    skordningPaborjadDatum?: Date;
    skotningAvslutadDatum?: Date;
}

export class VKAtgardKontraktDTO {
    affarsform?: string;
    guid: string;
    typ?: string;
}

export class VKAtgardKoppladAtgardDTO {
    avtalId?: number;
    kontraktId?: number;
    atgardId?: number;
    atgardGuid?: string;
    beteckning?: string;
    atgardsgrupp?: string;
    atgardstyp?: string;
}

export class VKAtgardAvverkningsTypDto {
    kod?: string;
    grupp?: string;
}

export type VkAtgardEntity = AtgardEntity | SkogsvardEntity;

export type AtgardEntity = EntityDTO & {
    avverkningsTyp?: VKAtgardAvverkningsTypDto;
};

export type SkogsvardEntity = EntityDTO & {
    grupp: string;
    typ: string;
    lopnummerKedja: number;
    lopnummer: number;
    createByCopy?: {
        copyFromKontraktGuid: string;
        copyFromAtgardGuid: string;
        copyFromAtgardId?: number;
        copyContractGeometries: boolean;
    };
};

export class VKSkogsvardsAtgard {
    skogsvardStatus?: string;
    skogsvardStatusHandelseDatum?: Date;
    skogsvardOnskatDatum?: Date;
    slutjusteradDatum?: Date;
}

export class VKAtgardDTO extends VKSkogsvardsAtgard {
    id?: number;
    beteckning?: string;
    externBeteckning?: string;
    atgardsnamn?: string;
    atgardstyp?: string;
    atgardsgrupp?: string;
    geometri?: string;
    nettoareal?: number;
    guid: string;
    status?: string;
    tillganglighetVag?: string;
    tillganglighetSkog?: string;
    skotningsavstand?: number;
    barighet?: number;
    ytstruktur?: number;
    lutning?: number;
    medelstam?: number;
    isMedelstamCalculated?: boolean;
    nvbHasMalklass?: boolean;
    antalFS?: number;
    grotuttagForeslaget?: boolean;
    uttagsanvisning?: string;
    nvBedomningUtfordDatum?: string;
    foreslagetProduktionsdatumFrom?: string;
    foreslagetProduktionsdatumTom?: string;
    arbetsorder: VKAtgardArbetsorderDTO;
    planerare?: AnsvarigAnvandare;
    avverkningsTyp: VKAtgardAvverkningsTypDto;
    centrumKoordinat?: string;
    utbyteInlastTid?: Date;
    utbyteInlastFran?: string;
    utbyteInlastAreal?: number;
    iDate: string;
    skonsamMarkbehandling?: string;
    kornstorlek?: string;
    markfuktighet?: string;
    slutrapportMeddelasMarkagare?: string;
    upphandlarkommentar?: string;
    onskatDatum?: Date;
    anteckningSkogsvard?: string;
    foryngringssatt?: string;
    malPlantorHa?: number;
    malFrogivaHa?: number;
    atgardsmetod?: string;
    datumSkordat?: Date;
    extraKartInfo?: AtgardStatusExtraKartinfo;
    anmalanSkogstyp?: string;
    kompatibilitet?: number;
    avverkningsanmalanKravs?: boolean;
    efterfoljandeAtgard?: string;
    grundytaForeAvv?: number;
    isGrundytaForeCalculated?: boolean;
    grundytaEfterAvv?: number;
    malklass?: string;
    hasForskottBetalning: boolean;
    indirektKostnad?: boolean;
    visaAnteckningSkogsvardIUtskrift?: boolean;
}

export class Atgard extends VKAtgardDTO {

    index?: number;
    lastSavedStatus?: string;

    get isFardigPlanerat() {
        return this.status === Planeringsstatus.Fardigplanerat;
    }

    get isUtfort(): boolean {
        return this.lastSavedStatus === Planeringsstatus.Utfort;
    }

    get isTillgangligt(): boolean {
        return this.lastSavedStatus === Planeringsstatus.Tillgangligt;
    }

    get isTillgangligtOrSenare(): boolean {
        return this.lastSavedStatus === Planeringsstatus.Tillgangligt ||
            this.lastSavedStatus === Planeringsstatus.Utfort ||
            this.lastSavedStatus === Planeringsstatus.Ajourhallet;
    }

    get isBetalningJusterbar(): boolean {
        // Plantleverans har ingen status hos SSP

        if(this.isPlantleverans && this.isTillgangligt) {
            return true;
        }

        return [
            SkogsvardStatus.slutrapporterad,
            SkogsvardStatus.godkand,
            SkogsvardStatus.ajourhallen
        ].includes(this.skogsvardStatus);
    }

    get isReadonly(): boolean {
        if (this.isSkogsvard) {
            return this.isTillgangligt || this.slutjusteradDatum != null;
        }

        if (this.isUtfort) {
            return true;
        }

        if (this.isLeveransvirke) {
            return false;
        }

        return (this.isTillgangligt);
    }

    get foreslagetProduktionsdatum() {
        const period = new Period();
        period.periodFrom = this.foreslagetProduktionsdatumFrom
            ? new Date(this.foreslagetProduktionsdatumFrom)
            : null;
        period.periodTom = this.foreslagetProduktionsdatumTom
            ? new Date(this.foreslagetProduktionsdatumTom)
            : null;

        return period;
    }

    get isGrot(): boolean {
        return this.atgardsgrupp === VirkeskopAtgardsgrupper.Grot;
    }

    get isLeveransvirke(): boolean {
        return this.atgardsgrupp === VirkeskopAtgardsgrupper.Leveransvirke;
    }

    get isSkogsvard(): boolean {
        return !!SkogsvardAtgardsGrupp.Alla.find(x => x === this.atgardsgrupp);
    }

    get isRojning(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.rojning;
    }

    get isForyngring(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.foryngring;
    }

    get isForyngringSadd(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.foryngring && this.atgardstyp === SkogsvardAtgardsTyp.foryngringSadd;
    }

    get isPlantleverans(): boolean {
        return Atgard.isPlantleverans(this.atgardsgrupp);
    }

    get isSkogsvardStatusInnanTilldelad(): boolean {
        return this.skogsvardStatus === SkogsvardStatus.ny ||
            this.skogsvardStatus === SkogsvardStatus.planerbar ||
            this.skogsvardStatus === SkogsvardStatus.planering;
    }

    get isMarkberedning(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.markberedning;
    }

    get isSiktrojning(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.rojning &&
            (this.atgardstyp === SkogsvardAtgardsTyp.siktrojning || this.atgardstyp === SkogsvardAtgardsTyp.nsSiktrojning);
    }

    get isInventering(): boolean {
        return this.atgardsgrupp === SkogsvardAtgardsGrupp.inventering;
    }

    tillganglighetItems: SimpleSelectionItem[] = [
        {
            id: "A",
            value: "A",
            text: "A Året om"
        },
        {
            id: "B",
            value: "B",
            text: "B Året om, ej tjällossning"
        },
        {
            id: "C",
            value: "C",
            text: "C Året om, ej tjällossning eller regnperioder"
        },
        {
            id: "D",
            value: "D",
            text: "D Vinter"
        }
    ];

    constructor(atg?: VKAtgardDTO) {
        super();
        this.id = atg?.id;
        this.beteckning = atg?.beteckning;
        this.externBeteckning = atg?.externBeteckning;
        this.atgardstyp = atg?.atgardstyp;
        this.atgardsgrupp = atg?.atgardsgrupp;
        this.geometri = atg?.geometri;
        this.nettoareal = atg?.nettoareal;
        this.guid = atg?.guid;
        this.planerare = atg?.planerare;
        this.status = atg?.status;
        this.tillganglighetSkog = atg?.tillganglighetSkog;
        this.tillganglighetVag = atg?.tillganglighetVag;
        this.skotningsavstand = atg?.skotningsavstand;
        this.barighet = atg?.barighet;
        this.ytstruktur = atg?.ytstruktur;
        this.lutning = atg?.lutning;
        this.medelstam = atg?.medelstam;
        this.isMedelstamCalculated = atg?.isMedelstamCalculated;
        this.antalFS = atg?.antalFS;
        this.grotuttagForeslaget = atg?.grotuttagForeslaget;
        this.uttagsanvisning = atg?.uttagsanvisning;
        this.foreslagetProduktionsdatumFrom = atg?.foreslagetProduktionsdatumFrom;
        this.foreslagetProduktionsdatumTom = atg?.foreslagetProduktionsdatumTom;
        this.arbetsorder = atg?.arbetsorder;
        this.atgardsnamn = atg?.atgardsnamn;
        this.planerare = atg?.planerare;
        this.avverkningsTyp = atg?.avverkningsTyp;
        this.centrumKoordinat = atg?.centrumKoordinat;
        this.lastSavedStatus = atg?.status;
        this.utbyteInlastTid = atg?.utbyteInlastTid;
        this.utbyteInlastFran = atg?.utbyteInlastFran;
        this.utbyteInlastAreal = atg?.utbyteInlastAreal;
        this.nvBedomningUtfordDatum = atg?.nvBedomningUtfordDatum;
        this.iDate = DateUtils.formatDateString(atg?.iDate, DateUtils.datetimeformatWithoutMillis);
        this.markfuktighet = atg?.markfuktighet;
        this.kornstorlek = atg?.kornstorlek;
        this.skonsamMarkbehandling = atg?.skonsamMarkbehandling;
        this.slutrapportMeddelasMarkagare = atg?.slutrapportMeddelasMarkagare;
        this.upphandlarkommentar = atg?.upphandlarkommentar;
        this.onskatDatum = atg?.onskatDatum;
        this.anteckningSkogsvard = atg?.anteckningSkogsvard;
        this.foryngringssatt = atg?.foryngringssatt;
        this.malPlantorHa = atg?.malPlantorHa;
        this.atgardsmetod = atg?.atgardsmetod;
        this.datumSkordat = atg?.datumSkordat;
        this.extraKartInfo = atg?.extraKartInfo;
        this.skogsvardStatus = atg?.skogsvardStatus;
        this.skogsvardStatusHandelseDatum = atg?.skogsvardStatusHandelseDatum;
        this.skogsvardOnskatDatum = atg?.skogsvardOnskatDatum;
        this.anmalanSkogstyp = atg?.anmalanSkogstyp;
        this.kompatibilitet = atg?.kompatibilitet;
        this.avverkningsanmalanKravs = atg?.avverkningsanmalanKravs;
        this.efterfoljandeAtgard = atg?.efterfoljandeAtgard;
        this.grundytaForeAvv = atg?.grundytaForeAvv;
        this.isGrundytaForeCalculated = atg?.isGrundytaForeCalculated;
        this.grundytaEfterAvv = atg?.grundytaEfterAvv;
        this.malklass = atg?.malklass;
        this.indirektKostnad = atg?.indirektKostnad;
        this.nvbHasMalklass = atg?.nvbHasMalklass;
        this.hasForskottBetalning = atg?.hasForskottBetalning;
        this.slutjusteradDatum = atg?.slutjusteradDatum;
        this.visaAnteckningSkogsvardIUtskrift = atg?.visaAnteckningSkogsvardIUtskrift;
    }

    static isPlantleverans(atgardsgrupp: string): boolean {
        return atgardsgrupp === SkogsvardAtgardsGrupp.plantleverans;
    }

    static isOvrigt(atgardsgrupp: string): boolean {
        return atgardsgrupp === SkogsvardAtgardsGrupp.ovrigt;
    }

    hasKompatibilitet(flag: VirkeskopsatgardKompatibilitet): boolean {
        return (this.kompatibilitet & flag) !== 0;
    }
}

export const ATGARD_PLANERINGSSTATUS = [
    Planeringsstatus.UnderPlanering,
    Planeringsstatus.Fardigplanerat,
    Planeringsstatus.Tillgangligt
];

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IAtgardstyper extends IAtgardstypResponse { }

export enum VirkeskopsatgardKompatibilitet {
    Alla = 0,
    LeveransvirkeInnanGeometri = 1 << 0,
}
